import { StyleSheet } from 'aphrodite'

import input from './input'

export default {
  input: StyleSheet.create(input)
}



// WEBPACK FOOTER //
// ./src/components/News/partials/PostEditor/style/ColorBlind/index.js